import * as actionTypes from "./actionTypes";
import {ESimService} from "../../api/eSimService";
import {store} from "../store";
import moment from "moment";
import {toastError} from "../../shared/components/toast/Toast";
import saveFileFromBlob from "../../shared/utils/fileUtils";

export const getEsitoInvioEmailTableData = (filter, sort, page, size) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const tipoDiRichiesta = filter.tipoDiRichiesta.value.length ? filter.tipoDiRichiesta.value : undefined
    const idLotto = filter.idLotto.value.length ? filter.idLotto.value : undefined
    const nTelefono = filter.numeroTelefono.value.length ? filter.numeroTelefono.value : undefined
    const seriale = filter.seriale.value.length ? filter.seriale.value : undefined
    const indirizzoEmail = filter.email.value.length ? filter.email.value : undefined
    const dataInvioFrom = filter.dataInvio.from ? moment(filter.dataInvio.from).format("YYYY-MM-DD") : undefined
    const dataInvioTo = filter.dataInvio.to ? moment(filter.dataInvio.to).format("YYYY-MM-DD") : undefined
    const esitoInvio = filter.esitoInvio.value.length ? filter.esitoInvio.value : undefined

    return (dispatch) => {
        dispatch({
            type: actionTypes.GET_ESITO_INVIO_EMAIL_TABLE_DATA,
            key: 'loading',
            value: true,
        })
        ESimService.fetchEsitoInvioEmail(integrationId, tipoDiRichiesta, idLotto, nTelefono, seriale,
             indirizzoEmail, dataInvioFrom, dataInvioTo, esitoInvio, page, size, sort)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_ESITO_INVIO_EMAIL_TABLE_DATA,
                    key: 'data',
                    value: res.data.data,
                })
                dispatch({
                    type: actionTypes.GET_ESITO_INVIO_EMAIL_TABLE_DATA,
                    key: 'total',
                    value: res.data.totalElements,
                })
            })
            .catch(err => {
                console.log(err)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_ESITO_INVIO_EMAIL_TABLE_DATA,
                    key: 'loading',
                    value: false,
                })
            })
    }
};

export const getEsitoInvioEmailFilterOptions = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return (dispatch) => {
        dispatch({
            type: actionTypes.GET_ESITO_INVIO_EMAIL_FILTER_OPTIONS,
            key: 'loading',
            value: true,
        })
        ESimService.fetchEsitoInvioEmailFilterOptions(integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_ESITO_INVIO_EMAIL_FILTER_OPTIONS,
                    key: 'data',
                    value: res.data,
                })
            })
            .catch(err => {
                console.log(err)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_ESITO_INVIO_EMAIL_FILTER_OPTIONS,
                    key: 'loading',
                    value: false,
                })
            })
    }
}

export const getParametriESimTableData = (filter, sorting, page, size) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    const nTelefono = filter.numeroDiTelefono.value.length ? filter.numeroDiTelefono.value : undefined
    const nSeriale = filter.numeroSeriale.value.length ? filter.numeroSeriale.value : undefined
    const statoSim = filter.statoSim.value.length ? filter.statoSim.value : undefined
    const emailInviata = filter.esitoInvio.value.length ? filter.esitoInvio.value : undefined

    return (dispatch) => {
        dispatch({
            type: actionTypes.GET_PARAMETRI_ESIM_TABLE_DATA,
            key: 'loading',
            value: true,
        })
        ESimService.fetchParametriESim(integrationId, nTelefono, nSeriale, statoSim, emailInviata, page, size, sorting)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_PARAMETRI_ESIM_TABLE_DATA,
                    key: 'data',
                    value: res.data.data,
                })
                dispatch({
                    type: actionTypes.GET_PARAMETRI_ESIM_TABLE_DATA,
                    key: 'total',
                    value: res.data.count,
                })
            })
            .catch(err => {
                console.log(err)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_PARAMETRI_ESIM_TABLE_DATA,
                    key: 'loading',
                    value: false,
                })
            })
    }
};

export const getParametriESimFilterOptions = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

    return (dispatch) => {
        dispatch({
            type: actionTypes.GET_PARAMETRI_ESIM_FILTER_OPTIONS,
            key: 'loading',
            value: true,
        })
        ESimService.fetchParametriESimFilterOptions(integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_PARAMETRI_ESIM_FILTER_OPTIONS,
                    key: 'data',
                    value: res.data,
                })
            })
            .catch(err => {
                console.log(err)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_PARAMETRI_ESIM_FILTER_OPTIONS,
                    key: 'loading',
                    value: false,
                })
            })
    }
}

export const importDistribuzioneEsim = (file, handleSetNextStep) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const formData = new FormData()
    formData.append( 'file', file)
    formData.append('integrationId', integrationId)

    return (dispatch) => {
        dispatch({
            type: actionTypes.IMPORT_DISTRIBUZIONE_ESIM,
            key: 'loading',
            value: true,
        })
        ESimService.importDistribuzioneEsim(formData)
            .then((res) => {
                dispatch({
                    type: actionTypes.IMPORT_DISTRIBUZIONE_ESIM,
                    key: 'data',
                    value: res.data.result,
                })
                if(handleSetNextStep) handleSetNextStep(1);
            })
            .catch(err => {
                console.log(err)
                toastError(err.response.data.message)
                dispatch({
                    type: actionTypes.IMPORT_DISTRIBUZIONE_ESIM,
                    key: 'data',
                    value: {
                        hasError: true,
                        errorMessage: err.response.data.message,
                        importaDistribuzioneDigitaleEsimList: []
                    },
                })
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.IMPORT_DISTRIBUZIONE_ESIM,
                    key: 'loading',
                    value: false,
                })
            })
    }
}

export const importDistribuzioneEsimSostitutive = (file, handleSetNextStep) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const formData = new FormData()
    formData.append( 'file', file)
    formData.append('integrationId', integrationId)

    return (dispatch) => {
        dispatch({
            type: actionTypes.IMPORT_DISTRIBUZIONE_ESIM_SOSTITUTIVE,
            key: 'loading',
            value: true,
        })
        ESimService.importDistribuzioneEsimSostitutive(formData)
            .then((res) => {
                dispatch({
                    type: actionTypes.IMPORT_DISTRIBUZIONE_ESIM_SOSTITUTIVE,
                    key: 'data',
                    value: res.data.result,
                })
                if(handleSetNextStep) handleSetNextStep(1);
            })
            .catch(err => {
                console.log(err)
                toastError(err.response.data.message)
                dispatch({
                    type: actionTypes.IMPORT_DISTRIBUZIONE_ESIM_SOSTITUTIVE,
                    key: 'data',
                    value: {
                        hasError: true,
                        errorMessage: err.response.data.message,
                        esimCsvValidationDistributionsItemList: []
                    },
                })
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.IMPORT_DISTRIBUZIONE_ESIM_SOSTITUTIVE,
                    key: 'loading',
                    value: false,
                })
            })
    }
}

export const distribuzioneEsim = (dtoBody, handleSetNextStep) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.DISTRIBUZIONE_ESIM,
            value: true,
        })
        ESimService.distribuzioneEsim(dtoBody)
            .then((res) => {
                handleSetNextStep(4);
            })
            .catch(err => {
                console.log(err)
                toastError(err.response.data.message)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.DISTRIBUZIONE_ESIM,
                    value: false,
                })
            })
    }
}

export const distribuzioneEsimSostitutive = (dtoBody, handleSetNextStep) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.DISTRIBUZIONE_ESIM,
            value: true,
        })
        ESimService.distribuzioneDigitaleEsimSostitutive(dtoBody)
            .then((res) => {
                handleSetNextStep(4);
            })
            .catch(err => {
                console.log(err)
                toastError(err.response.data.message)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.DISTRIBUZIONE_ESIM,
                    value: false,
                })
            })
    }
}

export const exportDistribuzioneEsimCsv = (dtoBody) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.EXPORT_DISTRIBUZIONE_ESIM_CSV,
            value: true,
        })
        ESimService.exportEsim(dtoBody)
            .then((res) => {
                if (res.status === 204) {
                    console.log("No content response.")
                    return;
                }
                saveFileFromBlob(res)
            })
            .catch(err => {
                console.log(err)
                toastError(err.response.data.message)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.EXPORT_DISTRIBUZIONE_ESIM_CSV,
                    value: false,
                })
            })
    }
}

    export const getEsitoCambioFormatoTableData = (filter, sorting, page, size) => {
        const integrationId = store.getState().authReducer.selectedCompany.integrationId
        const sortParts = sorting.split(',')
        const numeroDiTelefono = filter.numeroDiTelefono.value.length ? filter.numeroDiTelefono.value : undefined
        const nuovoSeriale = filter.numeroSeriale.value.length ? filter.numeroSeriale.value : undefined
        const idLotto = filter.idLotto.value.length ? filter.idLotto.value : undefined
        const esitoCambioFormato = filter.esitoCambioFormato.value.length ? filter.esitoCambioFormato.value : undefined
        const dataInvioRichiestaFrom = filter.dataInvioRichiesta.from ? moment(filter.dataInvioRichiesta.from).format("YYYY-MM-DD") : undefined
        const dataInvioRichiestaTo = filter.dataInvioRichiesta.to ? moment(filter.dataInvioRichiesta.to).format("YYYY-MM-DD") : undefined
        const email = filter.email.value.length ? filter.email.value : undefined

        return (dispatch) => {
            dispatch({
            type: actionTypes.GET_ESITO_CAMBIO_FORMATO_TABLE_DATA,
            key: 'loading',
            value: true,
             })
             ESimService.fetchEsitoCambioFormato(integrationId, page, size, sortParts[0], sortParts[1].toUpperCase(), idLotto, numeroDiTelefono, nuovoSeriale, esitoCambioFormato, dataInvioRichiestaFrom, dataInvioRichiestaTo, email)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_ESITO_CAMBIO_FORMATO_TABLE_DATA,
                    key: 'data',
                    value: res.data.data,
                })
                dispatch({
                    type: actionTypes.GET_ESITO_CAMBIO_FORMATO_TABLE_DATA,
                    key: 'total',
                    value: res.data.totalElements,
                })
            })
            .catch(err => {
                console.log(err)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_ESITO_CAMBIO_FORMATO_TABLE_DATA,
                    key: 'loading',
                    value: false,
                })
            })
    }
};

    export const getEsitoCambioFormatoFilterOptions = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;

        return (dispatch) => {
         dispatch({
            type: actionTypes.GET_ESITO_CAMBIO_FORMATO_FILTER_OPTIONS,
            key: 'loading',
            value: true,
            })
            ESimService.fetchEsitoCambioFormatoFilterOptions(integrationId)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_ESITO_CAMBIO_FORMATO_FILTER_OPTIONS,
                    key: 'data',
                    value: res.data,
                })
            })
            .catch(err => {
                console.log(err)
            })
                .finally(() => {
                    dispatch({
                        type: actionTypes.GET_ESITO_CAMBIO_FORMATO_FILTER_OPTIONS,
                        key: 'loading',
                        value: false,
                    })
                })
        }
    };

export const cambioFormattoDistribuzione = (dtoBody, handleSetStep) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.CAMBIO_FORMATO_DISTRIBUZIONE,
            value: true,
        })
        ESimService.cambioFormatoDistribuzione(dtoBody)
            .then((res) => {
                handleSetStep(5);
            })
            .catch(err => {
                console.log(err)
                toastError(err.response.data.message)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.CAMBIO_FORMATO_DISTRIBUZIONE,
                    value: false,
                })
            })
    }
}

export const cambioFormatto = (dtoBody, handleSetStep) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.CAMBIO_FORMATO,
            value: true,
        })
        ESimService.cambioFormato(dtoBody)
            .then((res) => {
                handleSetStep(3);
            })
            .catch(err => {
                console.log(err)
                toastError(err.response.data.message)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.CAMBIO_FORMATO,
                    value: false,
                })
            })
    }
}

export const fetchSostitutiveList = (simType) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({
            type: actionTypes.GET_SOSTITUTIVE_LIST,
            key: 'loading',
            value: true,
        })
        ESimService.fetchSostitutiveList(integrationId, simType)
            .then((res) => {
                dispatch({
                    type: actionTypes.GET_SOSTITUTIVE_LIST,
                    key: 'data',
                    value: res.data.result
                })
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.GET_SOSTITUTIVE_LIST,
                    key: 'loading',
                    value: false,
                })
            })
    }
}

export const exportSostitutiveListCsv = () => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId

    return (dispatch) => {
        dispatch({
            type: actionTypes.EXPORT_SOSTITUTIVE_LIST_CSV,
            value: true,
        })
        ESimService.exportSostituliveListCsv(integrationId)
            .then((res) => {
                if (res.status === 204) {
                    console.log("No content response.")
                    return;
                }
                saveFileFromBlob(res)
            })
            .catch(err => {
                console.log(err)
                toastError(err.response.data.message)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.EXPORT_SOSTITUTIVE_LIST_CSV,
                    value: false,
                })
            })
    }
}

export const importCambioFormatoDistribuzione = (file, handleSetNextStep) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const formData = new FormData()
    formData.append('file', file)
    formData.append('integrationId', integrationId)

    return (dispatch) => {
        dispatch({
            type: actionTypes.IMPORT_CAMBIO_FORMATO_DISTRIBUZIONE,
            key: 'loading',
            value: true,
        })
        ESimService.importCambioFormatoDistribuzioneCsv(formData)
            .then((res) => {
                dispatch({
                    type: actionTypes.IMPORT_CAMBIO_FORMATO_DISTRIBUZIONE,
                    key: 'data',
                    value: res.data.result,
                })
                if (handleSetNextStep) handleSetNextStep(1);
            })
            .catch(err => {
                console.log(err)
                toastError(err.response.data.message)
                dispatch({
                    type: actionTypes.IMPORT_CAMBIO_FORMATO_DISTRIBUZIONE,
                    key: 'data',
                    value: {
                        hasError: true,
                        errorMessage: err.response.data.message,
                        esimCsvValidationDistributionsReplacementsItemList: []
                    },
                })
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.IMPORT_CAMBIO_FORMATO_DISTRIBUZIONE,
                    key: 'loading',
                    value: false,
                })
            })
    }
}

export const exportCambioFormatoDistribuzione = (dtoBody) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.EXPORT_CAMBIO_FORMATO_DISTRIBUZIONE,
            value: true,
        })
        ESimService.exportCambioFormatoDistribuzioneCsv(dtoBody)
            .then((res) => {
                if (res.status === 204) {
                    console.log("No content response.")
                    return;
                }
                saveFileFromBlob(res)
            })
            .catch(err => {
                console.log(err)
                toastError(err.response.data.message)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.EXPORT_CAMBIO_FORMATO_DISTRIBUZIONE,
                    value: false,
                })
            })
    }
}

export const importCambioFormatoCsv = (file, handleSetNextStep) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const formData = new FormData()
    formData.append('file', file)
    formData.append('integrationId', integrationId)

    return (dispatch) => {
        dispatch({
            type: actionTypes.IMPORT_CAMBIO_FORMATO_CSV,
            key: 'loading',
            value: true,
        })
        ESimService.importCambioFormattoCsv(formData)
            .then((res) => {
                dispatch({
                    type: actionTypes.IMPORT_CAMBIO_FORMATO_CSV,
                    key: 'data',
                    value: res.data.result,
                })
                if (handleSetNextStep) handleSetNextStep(1);
            })
            .catch(err => {
                console.log(err)
                toastError(err.response.data.message)
                dispatch({
                    type: actionTypes.IMPORT_CAMBIO_FORMATO_CSV,
                    key: 'data',
                    value: {
                        hasError: true,
                        errorMessage: err.response.data.message,
                        esimCsvValidationDistributionsReplacementsItemList: []
                    },
                })
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.IMPORT_CAMBIO_FORMATO_CSV,
                    key: 'loading',
                    value: false,
                })
            })
    }
}

export const exportCambioFormato = (dtoBody) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.EXPORT_CAMBIO_FORMATO_CSV,
            value: true,
        })
        ESimService.exportCambioFormatoCsv(dtoBody)
            .then((res) => {
                if (res.status === 204) {
                    console.log("No content response.")
                    return;
                }
                saveFileFromBlob(res)
            })
            .catch(err => {
                console.log(err)
                toastError(err.response.data.message)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.EXPORT_CAMBIO_FORMATO_CSV,
                    value: false,
                })
            })
    }
}

export const exporteMassiveTags = (dtoBody) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.EXPORT_MASSIVE_TAGS_CSV,
            value: true,
        })
        ESimService.exportMassiveTagsCsv(dtoBody)
            .then((res) => {
                if (res.status === 204) {
                    console.log("No content response.")
                    return;
                }
                saveFileFromBlob(res)
            })
            .catch(err => {
                console.log(err)
                toastError(err.response.data.message)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.EXPORT_MASSIVE_TAGS_CSV,
                    value: false,
                })
            })
    }
}
export const importMassiveTags = (file, handleSetNextStep) => {
    const integrationId = store.getState().authReducer.selectedCompany.integrationId;
    const formData = new FormData()
    formData.append( 'file', file)
    formData.append('integrationId', integrationId)

    return (dispatch) => {
        dispatch({
            type: actionTypes.IMPORT_MASSIVE_TAGS_CSV,
            key: 'loading',
            value: true,
        })
        ESimService.importMassiveTagsCsv(formData)
            .then((res) => {
                dispatch({
                    type: actionTypes.IMPORT_MASSIVE_TAGS_CSV,
                    key: 'data',
                    value: res.data.result.rows,
                })
                if(handleSetNextStep) handleSetNextStep(1);
            })
            .catch(err => {
                console.log(err)
                toastError(err.response.data.message)
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.IMPORT_MASSIVE_TAGS_CSV,
                    key: 'loading',
                    value: false,
                })
            })
    }
}
export const insertBatchAssociateTags = (dtoBody, handleSetNextStep) => {

    return (dispatch) => {
        dispatch({
            type: actionTypes.INSERT_BATCH_ASSOCIATE_TAGS,
            key: 'loading',
            value: true,
        })
        ESimService.batchAssociateTags(dtoBody)
            .then((res) => {
                dispatch({
                    type: actionTypes.INSERT_BATCH_ASSOCIATE_TAGS,
                    key: 'data',
                    value: res.data,
                })
                if(handleSetNextStep) handleSetNextStep(2);
            })
            .catch(err => {
                console.log(err)
                dispatch({
                    type: actionTypes.INSERT_BATCH_ASSOCIATE_TAGS,
                    key: 'data',
                    value: {
                        hasError: true,
                        errorMessage: err.response.data.message,
                    }
                })
                if(handleSetNextStep) handleSetNextStep(2);
            })
            .finally(() => {
                dispatch({
                    type: actionTypes.INSERT_BATCH_ASSOCIATE_TAGS,
                    key: 'loading',
                    value: false,
                })
            })
    }
}
export const storeRadioButtonValue = (radioButton) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.STORE_RADIO_VALUE,
            value: radioButton,
        })
    }
}